import React from 'react';
import OptimizedIframe from './OptimizedFrame';
import ContactForm from './ContactForm';

const VendorLayout = ({ vendorDetails }) => {
  // Pre-calculate visibility state once
  const hasIframe = Boolean(true || vendorDetails?.website_iframe === 1 && vendorDetails?.website);
  
  return (
    <div className="py-6 mx-auto md:mx-0 max-w-8xl md:mt-8 lg:mt-6 xl:mt-6">
      <div 
        className="grid grid-cols-1 lg:grid-cols-3 gap-8"
        style={{
          // Force GPU acceleration
          transform: 'translateZ(0)',
          // Ensure layout stability
          willChange: 'contents',
          // Hide grid when no iframe
          display: hasIframe ? 'grid' : 'block'
        }}
      >
        <div 
          className="lg:col-span-2 mt-2"
          style={{
            // Hide iframe container when not needed
            display: hasIframe ? 'block' : 'none',
            // Reserve space to prevent layout shift
            minHeight: hasIframe ? '400px' : '0'
          }}
        >
          {hasIframe && (
            <OptimizedIframe 
              url={vendorDetails.website} 
              title="Vendor Website" 
            />
          )}
        </div>
        <div 
          className={`${hasIframe ? '' : 'w-full'}`}
          style={{
            // Center form when no iframe
            margin: hasIframe ? '0' : '0 auto',
            maxWidth: hasIframe ? 'none' : '32rem'
          }}
        >
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default VendorLayout;